import React, { FC, memo, useMemo } from 'react'
import Image from 'next/image'
import styled from 'styled-components'
import SC from '../base/Person.styles'
import { IPersonProps } from '../types'
import { Grid, GridCol } from '../../Grid/desktop'
import { Text } from '../../Text/desktop'
import { Spacing } from '../../Spacing/desktop'

const { Block, ImageWrapper } = SC

const Img = styled.img`
  object-fit: cover;
`

/** Персона */
const Person: FC<IPersonProps> = (props) => {
  const {
    name,
    href,
    hint,
    imgUrl,
    hintSize,
    imgSize,
    nameSize,
    nameSpacing = 'uxsmall',
    nameFontWeight = 'bold',
  } = props

  const imgPxSize = useMemo(() => {
    switch (imgSize) {
      case 'small':
        return 24
      case 'medium':
        return 48
      case 'large':
        return 56
      case 'xlarge':
        return 64
      default:
        return 16
    }
  }, [imgSize])

  const imgColWidth = useMemo(() => `${imgPxSize + 16}px`, [imgPxSize])

  const fullUrlImg = useMemo(() => {
    if (imgUrl && imgUrl?.includes('ucheba')) {
      return imgUrl
    }

    return null
  }, [imgUrl])

  return (
    <Block as={href ? 'a' : 'div'} href={href}>
      <Grid spacing='xsmall'>
        {imgUrl && (
          <>
            {fullUrlImg ? (
              <GridCol width={imgColWidth}>
                <ImageWrapper>
                  <Img src={fullUrlImg} width={imgPxSize} height={imgPxSize} />
                </ImageWrapper>
              </GridCol>
            ) : (
              <GridCol width={imgColWidth}>
                <ImageWrapper>
                  <Image src={imgUrl} width={imgPxSize} height={imgPxSize} alt='' />
                </ImageWrapper>
              </GridCol>
            )}
          </>
        )}

        <GridCol width='75%'>
          {name && (
            <Text
              fontWeight={nameFontWeight}
              color='black'
              fontSize={nameSize}
              html={false}
            >
              {name}
            </Text>
          )}

          {hint && (
            <>
              <Spacing spacing={nameSpacing} />

              <Text fontSize={hintSize} color='black' html={false} wordBreak='break-word'>
                {hint}
              </Text>
            </>
          )}
        </GridCol>
      </Grid>
    </Block>
  )
}

export { Person }
export default memo(Person)
